<div *ngIf="hierarchyItem && (!hierarchyItem.isChangeKey || showChangeKeys)" class="menu-container only-tree no-min">
  
<form [formGroup]="form">
  <div class="row">
<!-- Key Set Symbol -->
<div class="keyset-symbol-wrapper">
  <div class="keyset-symbol">
    <div
      *ngFor="let level of hierarchyItem?.lineTracker | keyvalue; let first = first; let last = last"
      class="lines"
    >
      <div *ngIf="level.value.key === hierarchyItem.keySetSymbol" class="top"></div>
      <div class="bottom" [ngClass]="{ 'no-border': level.value.value }"></div>
    </div>

    <!-- Key Tree -->
    <lib-key
      [canMinimize]="true"
      [selectedMasterKey]="selectedMasterKey"
      [hierarchyItem]="hierarchyItem"
      [showChangeKeys]="showChangeKeys"
      (click)="selectMasterKey(hierarchyItem)"
    >
      <div class="status-icons" [ngClass]="{ 'no-min': !hasMinimize(hierarchyItem) }">
        <mat-icon
          matTooltipShowDelay="400"
          matTooltip="Key is Assigned"
          *ngIf="hierarchyItem.isAssigned"
        >check</mat-icon>
      </div>
    </lib-key>
  </div>
</div>

<!-- Active TMK -->
<div class="col fixWidthActiveTMK" >
  <div *ngIf="keySystem?.constructionTypeId && keySystem?.constructionTypeId !== 1 && hierarchyItem.masterKeyTypeId === 9">
    <mat-slide-toggle
      *ngIf="!hierarchyItem.disableTMKToggling"
      #toggle
      [checked]="isActiveTopMasterKey"
      (change)="setActiveTopMasterKey(hierarchyItem, $event)"
      [color]="'primary'"
      formControlName="isActiveTmk"
      ><span *ngIf="isActiveTopMasterKey">On</span>
      <span *ngIf="!isActiveTopMasterKey">Off</span>
    </mat-slide-toggle>
  </div>
</div>


<!-- Key Section -->
<div class="col fixWidthKeySection">
  <div class="input">
    <input
      matInput
      #inputRef="matAutocompleteTrigger" 
      aria-describedby="keySections"
      [matAutocomplete]="auto"
      (focus)="loadKeyways(hierarchyItem)"
      formControlName="keySection"
      (keydown)="onChange($event, 'keySection', inputRef)"
      (blur)="onKeySectionBlur($event)"
      matAutocompleteTrigger
    />

    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let keySection of childKeySections" [value]="keySection" (onSelectionChange)="saveKeySection(keySection, $event)">

        {{ keySection.name }}
      </mat-option>
    </mat-autocomplete>
  </div>
</div>

<!-- Bitting -->
<div class="col fixWidthBitting">
  <div class="input">
    <input  
    #inputRef  
    formControlName="masterKeyBitting"  
    (input)="saveMasterKeyBitting($event, $event.target.value)"
    (keydown)="onKeyDown($event)"
    (keyup)="onChange($event, 'masterKeyBitting')"
    type="text"  
    pattern="[0-9]*"  
    [maxlength]="maxBittingLength"  
  />
  </div>
</div>
  </div>
    
  </form>
</div>

<ng-container
  *ngIf="hierarchyItem && !hierarchyItem.isChangeKey && hierarchyItem.children && hierarchyItem.children.length > 0"
>
  <div *ngFor="let child of hierarchyItem.sortedChildren; let last = last">
    <lib-dealer-masterkey-tree
      *ngIf="
        !hierarchyItem?.isMinimized &&
        child?.masterKeyTypeId !== 12 &&
        child?.masterKeyTypeId !== 14 &&
        child?.masterKeyTypeId !== 99 &&
        child?.masterKeyTypeId !== 100 &&
        child?.masterKeyTypeId !== 3
      "
      [showChangeKeys]="showChangeKeys"
      [hierarchyItem]="child"
      [structure]="structure"
      [keySystem]="keySystem"
      [keySections]="keySections"
      [dealerMasterKeys]="dealerMasterKeys"
      [lastChild]="last"
      (patchItemAction)="patchItem($event)"
      (dealererror)="handleDealerError($event)"
      (isEditing)="isEditingCounter($event)"
    >
    </lib-dealer-masterkey-tree>
  </div>
</ng-container>
